import { PropTypes } from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';
import { TransitionGroup } from 'react-transition-group';
import { withTheme } from '@material-ui/core/styles';
import FadeTransition from 'shared/components/FadeTransition';
import IndeterminateCircularProgress from 'shared/components/IndeterminateCircularProgress';
import React from 'react';
import CategoryCard from './CategoryCard';
import styles from './styles.css';

const SubCategoryDrawer = props => {
	const { theme } = props;
	// category-scroller-spacing is used to create a percentage of padding between the category scroller and content above
	return (
		<div
			className={styles['subcategory-drawer']}
			style={{ backgroundColor: theme.palette.primary.main }}
		>
			{props.categories.length === 0 ? (
				<IndeterminateCircularProgress size={90} isVisible={props.isFetching} />
			) : (
				<Scrollbars>
					<div className={styles['category-scroller-padding']}>
						{/* Fade in/fade out the category cards */}
						<TransitionGroup style={{ height: '100%' }}>
							{props.categories.map(category => (
								<FadeTransition key={category.categoryId}>
									<div className={styles['category-scroller-card']}>
										<CategoryCard
											id={category.categoryId}
											cat={category.name}
											pictureUrl={category.pictureUrl}
										/>
									</div>
								</FadeTransition>
							))}
						</TransitionGroup>
					</div>
				</Scrollbars>
			)}
		</div>
	);
};

SubCategoryDrawer.propTypes = {
	categories: PropTypes.arrayOf(
		PropTypes.shape({
			categoryId: PropTypes.number,
			name: PropTypes.string,
			pictureUrl: PropTypes.string,
		}),
	).isRequired,
	isFetching: PropTypes.bool.isRequired,
	theme: PropTypes.instanceOf(Object).isRequired,
};

// for testing purposes
export { SubCategoryDrawer as CategoryScrollerClass };

export default withTheme(SubCategoryDrawer);
